$(function(){
$('.js-search-open').on('click',function(){
  let $this = $(this);
  let $searchBlock = $('.js-search-block');
  $searchBlock.addClass('is-show');
});

$('.js-search-close').on('click',function(){
  let $this = $(this);
  let $searchBlock = $('.js-search-block');
  $searchBlock.removeClass('is-show');
});
});

